services.service('GoogleAuthProvider', [
    '$q', 'ExternalScriptLoader',

    function ($q, ExternalScriptLoader) {
        function GoogleAuthProvider(config) {
            var self = this;

            var loader = new ExternalScriptLoader();
            var id = config.id;
            var auth2 = null;
            self.ready = false;

            this.init = function () {
                var gapiInit = function () {

                    return $q(function (resolve, reject) {

                        function onLoad() {
                            auth2 = gapi.auth2.init({client_id: id});
                            auth2
                                .then(function () {
                                    self.ready = true;
                                    resolve()
                                })
                                .catch(function (error) {
                                    self.re = false;
                                    reject(error)
                                })
                        }

                        gapi.load('auth2', onLoad)
                    })
                }


                return loader.load('https://apis.google.com/js/platform.js')
                    .then(gapiInit)
            }


            this.isLoggedIn = function () {
                return $q.resolve()
                    .then(function () {
                        return auth2.isSignedIn.get()
                    })
            }

            this.signIn = function (opts) {
                return auth2.signIn(opts)
                    .then(self.getUser)
            }

            this.signOut = function (revoke) {
                return revoke
                    ? auth2.disconnect()
                    : auth2.signOut()
            }

            this.getUser = function () {
                if (!self.isLoggedIn()) {
                    return $q.resolve(null)
                }

                var profile = auth2.currentUser.get().getBasicProfile();
                var token = auth2.currentUser.get().getAuthResponse(true).access_token;
                var backendToken = auth2.currentUser.get().getAuthResponse(true).id_token;

                var user = {
                    provider: "google",
                    id: profile.getId(),
                    email: profile.getEmail(),
                    name: profile.getName(),
                    photoUrl: profile.getImageUrl(),
                    firstName: profile.getGivenName(),
                    lastName: profile.getFamilyName(),
                    token: token,
                    idToken: backendToken,
                }
                return $q.resolve(user)
            }

        }

        return GoogleAuthProvider
    }
])
